/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Share = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M13 12c-.7 0-1.4.2-1.9.7l-3.2-2c.1-.5.1-.9 0-1.4l3.2-2c.5.5 1.2.7 1.9.7 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .2 0 .4.1.7l-3.2 2C6.4 7.2 5.7 7 5 7c-1.7 0-3 1.3-3 3s1.3 3 3 3c.7 0 1.4-.2 1.9-.7l3.2 2c0 .2-.1.4-.1.7 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3z" />
  </svg>
);

export default extendIcon(Share);
